module.exports = __webpack_public_path__ + "static/media/icon_matching.2633f752.svg";